import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "register-form-row" }
const _hoisted_3 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_4 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_5 = { class: "register-form-row" }
const _hoisted_6 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_7 = {
  key: 1,
  class: "error-msg"
}
const _hoisted_8 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_9 = { class: "register-form-row" }
const _hoisted_10 = ["type"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 17" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-form-eye" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L19 19",
    stroke: "black",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_15 = ["type"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 17" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-form-eye" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L19 19",
    stroke: "black",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_20 = { class: "register-form-foot" }
const _hoisted_21 = { class: "register-form-foot-text text" }
const _hoisted_22 = {
  key: 1,
  type: "button",
  disabled: "",
  class: "button button--loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!

  return (_openBlock(), _createElementBlock("form", {
    class: "register-form form",
    onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("h3", {
      class: "register-form-title h4",
      innerHTML: _ctx.title
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.first-name')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.firstname.$touch && _ctx.v$.firstname.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.firstname.$errors.length }),
          type: "text",
          name: "firstname",
          minlength: "2",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.firstname,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$.firstname.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.v$.firstname.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.last-name')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastname) = $event)),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.lastname.$touch && _ctx.v$.lastname.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.lastname.$errors.length }),
          type: "text",
          name: "lastname",
          minlength: "2",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.lastname,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$.lastname.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.v$.lastname.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.email')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.email.$touch && _ctx.v$.email.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.isAlreadyExist || _ctx.v$.email.$errors.length }),
          type: "email",
          name: "email",
          required: "",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.email]
        ]),
        (_ctx.isAlreadyExist)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errorEmail), 1))
          : (_ctx.v$.email.$errors.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.v$.email.$errors[0].$message), 1))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.confirm-email')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailConfirm) = $event)),
          onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.emailConfirm.$touch && _ctx.v$.emailConfirm.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.emailConfirm.$errors.length }),
          type: "email",
          name: "emailConfirm",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.emailConfirm]
        ]),
        (_ctx.v$.emailConfirm.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.v$.emailConfirm.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.password')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.password) = $event)),
          onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.password.$touch && _ctx.v$.password.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.password.$errors.length }),
          type: _ctx.isPasswordObscurated ? 'password' : 'text',
          name: "password",
          minlength: "8",
          required: "",
          autocomplete: "off",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 42, _hoisted_10), [
          [_vModelDynamic, _ctx.password]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass([{ 'active': _ctx.isPasswordObscurated }, "form__hide"]),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isPasswordObscurated = !_ctx.isPasswordObscurated)),
          tabindex: "-1"
        }, _hoisted_13, 2),
        (_ctx.v$.password.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.v$.password.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.confirm-password')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.passwordConfirm) = $event)),
          onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.passwordConfirm.$touch && _ctx.v$.passwordConfirm.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.passwordConfirm.$errors.length }),
          type: _ctx.isPasswordObscurated2 ? 'password' : 'text',
          name: "passwordConfirm",
          minlength: "8",
          required: "",
          autocomplete: "off",
          spellcheck: "false",
          autocapitalize: "off",
          autocorrect: "off"
        }, null, 42, _hoisted_15), [
          [_vModelDynamic, _ctx.passwordConfirm]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass([{ 'active': _ctx.isPasswordObscurated2 }, "form__hide"]),
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isPasswordObscurated2 = !_ctx.isPasswordObscurated2)),
          tabindex: "-1"
        }, _hoisted_18, 2),
        (_ctx.v$.passwordConfirm.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.v$.passwordConfirm.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "hidden",
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.lang) = $event)),
      name: "lang"
    }, null, 512), [
      [_vModelText, _ctx.lang]
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("p", _hoisted_21, [
        _createTextVNode(_toDisplayString(_ctx.$t('register-form.already-member')) + " ", 1),
        _createVNode(_component_RouterLink, {
          to: "/login",
          class: "link-secondary font-semibold"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('register-form.sign-in')), 1)
          ]),
          _: 1
        })
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ButtonHover, {
            key: 0,
            type: "submit",
            class: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('register-form.next')), 1)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("button", _hoisted_22, _toDisplayString(_ctx.$t('register-form.loading')), 1))
    ]),
    _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"])
  ], 32))
}